import { createFileRoute } from "@tanstack/react-router";
import { buildHref } from "@softmax/web-addresses";
import { canonicalSiteUrl } from "@softmax/web-addresses/discovery";

import { BrowsePage } from "@/features/discovery";
import { browseCatalogQueryOptions } from "@/features/discovery/records";

const description =
  "Discover Softmax coworlds. Pick one to read its rules, watch it played and enter a player of your own.";

const href = canonicalSiteUrl(buildHref({ name: "browse" }));

export const Route = createFileRoute("/_site/browse")({
  validateSearch: (raw): { cursor?: string } =>
    typeof raw.cursor === "string" ? { cursor: raw.cursor } : {},
  loaderDeps: ({ search }) => search,
  loader: async ({ context, location }) => {
    const options = browseCatalogQueryOptions(location.href);

    void context.queryClient.prefetchQuery(options);
  },
  head: () => ({
    meta: [
      { title: "Coworlds · Softmax" },
      { name: "description", content: description },
      { property: "og:title", content: "Coworlds · Softmax" },
      { property: "og:description", content: description },
      { property: "og:url", content: href },
    ],
    links: [{ rel: "canonical", href }],
  }),
  component: BrowsePage,
});
